import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PopoverController } from '@ionic/angular';

import { NavigationBasePage } from '@shared/pages'
import type { TNavigationViewModel, TShuttle } from '@shared/models';
import type { Subscription } from 'rxjs';

@Component({
    'selector': 'app-navigation1ShuttleSelection',
    'templateUrl': './navigation1ShuttleSelection.page.html',
    'styleUrls': ['./navigation1ShuttleSelection.page.scss'],
    standalone: true,
    imports: [ CommonModule, FormsModule, IonicModule ]
})
export class Navigation1ShuttleSelectionPage extends NavigationBasePage implements OnInit, OnDestroy {
    public vm: TNavigationViewModel;
    // private selectedShuttleUid: string;
    // private shuttlesSubscription: any;
    private shuttlesSubscription: Subscription;

    constructor( public popoverCtrl: PopoverController, injector: Injector) {
        super(injector);
        this.initializeVm();
    }

    public override ngOnInit(): void {
        super.ngOnInit();
    }

    public async ionViewWillEnter(): Promise<void> {
        // super.setCurrentView(this.Constants.VIEW_NAVIGATION_PAGE1);
        super.setCurrentView(this.Constants.VIEW_NAVIGATION);

        // super.ngOnInit();
        // this.eventsService.publish(Constants.EVENT_NAV_MORE_MENU_CHANGE);

        await this.loadAssignedShuttles();

        // We don't want the driver to be fumbling with the phone trying to get the application to wake up.
        // Prevent all the NavigationN pages from falling asleep. 
        // this.keepAwake();
        this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
        if (this.shuttlesSubscription) {
            this.shuttlesSubscription.unsubscribe();
        }
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tickets');
        this.supplyDebugMenuItems();
        // this.pushPopoverMenuItem('Show Tour', 'show-navigation-1-tour');
        // this.moreMenuItemClick(this.handleMenuItemClick);
        this.handleMenuItemClick('Show Tickets', this.vm);  // 
    }

    // There is no sense in prompting for a shuttle if the shuttle hasn't had a route
    // defined for it yet.  So this routine will return those shuttle names that have
    // routes assigned.
    private async loadAssignedShuttles(): Promise<void> {
        await this.uxHelperService.showSpinner();

        const observable = this.shuttlesService.getObservable();
        this.shuttlesSubscription = observable.subscribe(async (shuttles: TShuttle[]) => {
            const assignedShuttles = shuttles.filter((shuttle) => (shuttle.status === 'Assigned'));

            this.vm.shuttles = this.shuttlesService.sort(assignedShuttles);
        });
        // super.registerSubscription(this.shuttlesSubscription);
        await this.uxHelperService.hideSpinner();
    }

    public async onNextClick() {
        if (this.vm.step1Complete) {
            this.vm.route = await this.routesService.getByUid(this.vm.selectedShuttle.uid);

            super.setViewModel(this.vm);
            this.router.navigateByUrl('/navigation/navigation2Attendance');
        } else {
            await this.uxHelperService.showAlert('Error', 'Please select a shuttle first.');
        }
    }

    public onShuttleClick(shuttle: TShuttle) {
        // this.selectedShuttleUid = shuttle.uid;
        this.vm.selectedShuttle = shuttle;
        this.vm.step1Complete = true;
    }

    private async initializeVm() {
        this.vm = {
            'assignedTickets': [],
            'completedTickets': [],
            'currentTickets': [],
            'distanceFromDestination': { 'miles': 0, 'kilometers': 0 },
            'dropoffTickets': [],
            'enrouteTickets': [],
            'pickupTickets': [],
            'tickets': [],
            'shuttles': [],
            'selectedShuttle': this.shuttlesService.getNullableShuttle(),   // was null
            'currentTicket': null,
            'route': null,
            'myVector': this.shuttlesService.getNullableVector(),
            'trip': null,

            'numAttendees': 0,
            'numDropoffsStr': '',
            'attendanceSummary': '',
            'numEmptySeats': 0,
            'step1Complete': false,
            'step2Complete': false,
            'step3Complete': false,
            'currentLegIdx': 0,
            'isDebugMode': this.sessionService.isDebugMode(),

            'currentLeg': {
                'from': {
                    'location': {
                        'address': null,
                        'locationName': '',
                    },
                    'passengerName': '',
                    'letter': '',
                    'waypointNumber': 0
                },
                'to': {
                    'location': {
                        'address': null,
                        'locationName': '',
                    },
                    'passengerName': '',
                    'letter': '',
                    'waypointNumber': 0
                },
                'isUrgent': false,
                'letter': '',
                'passengerName': '',
                'status': '',
                'ticketUid': '',
                'waypointNumber': 0,
            },
        }
    }
}